<template>
    <div class="app-footer">
        <AonContainer class="app-footer__container pb-md pt-xl" add-page-padding>
            <AonRow>
                <AonCol class="grid-cols-12 justify-between p-0">
                    <div class="app-footer__copyright display-flex flex-wrap">
                        <p class="app-footer__text small text-on-dark">
                            {{ t('global.footer.copyright1', { year }) }}
                        </p>
                        <p class="app-footer__text display-flex small text-on-dark mt-md">
                            {{ t('global.footer.copyright2') }}
                        </p>
                    </div>
                </AonCol>
            </AonRow>
            <AonRow>
                <AonCol class="grid-cols-12 justify-between p-0 align-items-center">
                    <div class="app-footer__content display-flex w-100 justify-between">
                        <div class="app-footer__logo-container display-flex align-items-center">
                            <img
                                class="app-footer__logo mr-sm"
                                :alt="`Aon ${t('global.title')}`"
                                src="@/assets/moat-logo.svg"
                            />
                            <h6 class="app-footer__company-name text-on-dark">
                                © {{ year }} Moat Metrics, Inc
                            </h6>
                        </div>

                        <div class="app-footer__links display-flex align-items-center">
                            <p class="app-footer__link-item bold">
                                <a
                                    href="https://moatmetrics.com/util/privacy-center"
                                    target="_blank"
                                    class="app-footer__link px-sm mx-sm text-accent"
                                >
                                    {{ t('global.footer.privacy') }}
                                </a>
                            </p>
                            <p class="app-footer__link-item bold text-on-dark">
                                {{ t('global.footer.financialDataBy') }}
                                <a
                                    href="http://www.crunchbase.com"
                                    target="_blank"
                                    class="app-footer__link mr-md text-accent"
                                >
                                    Crunchbase
                                </a>
                            </p>
                            <p class="app-footer__link-item bold text-on-dark">
                                {{ t('global.footer.rawDataBy') }}
                                <a
                                    class="app-footer__link text-accent"
                                    href="https://www.factset.com/data-attribution"
                                    target="_blank"
                                >
                                    Factset
                                </a>
                            </p>
                            <a
                                class="app-footer__social-link text-accent ml-sm"
                                href="https://moatmetrics.notion.site/94052d1802e74047a9f9250c8cc76da5?v=eb8c674d15504eb48abd510bc4133c14"
                                target="_blank"
                            >
                                <img
                                    class="app-footer__social-icon mx-sm mt-xxs"
                                    alt="Moat Metrics LinkedIn"
                                    src="@/assets/icon/notion-logo.svg"
                                />
                            </a>
                            <a
                                class="app-footer__social-link text-accent"
                                href="https://www.linkedin.com/company/moat-metrics/"
                                target="_blank"
                            >
                                <img
                                    class="app-footer__social-icon mx-sm mt-xxs"
                                    alt="Moat Metrics LinkedIn"
                                    src="@/assets/icon/linkedin-logo.svg"
                                />
                            </a>
                        </div>
                    </div>
                </AonCol>
            </AonRow>
        </AonContainer>
        <div class="app-footer__gradient"></div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const year = computed(() => {
    return new Date().getFullYear()
})
</script>

<style lang="scss" scoped>
.app-footer {
    width: 100%;
    background-color: var(--color-primary-darker);
    position: sticky;
    bottom: 0;
    left: 0;
    z-index: var(--z-default);

    &__logo {
        height: 40px;
    }

    &__text {
        color: var(--color-text-on-dark);
    }

    &__company-name {
        color: var(--color-text-on-dark);
    }

    &__link-item {
        color: var(--color-text-on-dark);
    }

    &__link {
        color: var(--color-accent);
    }

    &__social-link {
        color: var(--color-accent);
    }

    &__social-icon {
        height: 20px;
    }

    &__gradient {
        width: 100%;
        height: 15px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        border-top: var(--border-width-thick) solid var(--color-background-light);
        background: linear-gradient(
            to bottom,
            rgba(124, 142, 174, 0.4) 0%,
            rgba(16, 43, 71, 0) 100%
        );
    }
}
</style>
